export default __webpack_public_path__ + "static/media/1.0a556d13.png";